import { useMutation } from '@tanstack/react-query';
import { Endpoint } from '@/Config/api/endpoint';
import { KnowledgeBaseApi } from '@/Domain/api/KnowledgeBase/KnowledgeBase.api';
import { ParagraphDto } from '@/Domain/api/KnowledgeBase/dto/Article.dto';

export const useUpdateParagraph = (articleId: number) => {
  const mutation = useMutation({
    mutationKey: [Endpoint.knowledgeBase.articles.update, articleId],
    mutationFn: (data: ParagraphDto) => KnowledgeBaseApi.updateArticle(articleId, data),
  });

  const handleUpdateParagraph = (data: ParagraphDto) => mutation.mutate(data);

  return {
    handleUpdateParagraph,
  };
};
